<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>

             <form-group label="Brand" :required="true">
             <input
                @blur="$v.brand.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.brand.name.$error }"
                v-model="brand.name"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.brand.name.required"
              >
                Please enter brand
              </div>
            </form-group>
      

            <form-group label="Image">
              <image-upload
                @files-uploaded="
                  brand.image_id = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="false"
                :imageCrop=true
                :imageCropRatio=1/1
                :validationState="imageVstate"
                acceptedTypes="image/*"
              />
            </form-group>



          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import brandRepo from "@/api/repos/brandRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    brand: {     
      name: {
        required,
      },
    },
  },

  mounted() {
    this.getBrand();
  },

  props: ["id"],

  data() {
    return {
      brand: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
   
    async getBrand() {
      try {
        this.loading = true;
        let { data } = await brandRepo.get(this.id);
        this.brand = data.brand;       
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await brandRepo.update(this.id, this.brand);
          this.$emit("brandUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
